import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Check, Trash2, X } from "lucide-react";

export function EditItemVariationsModal({
  isOpen,
  onClose,
  item,
  onSave,
  isSaving,
}) {
  if (!item || !item.selected_variations?.length) return null;

  const handleRemoveVariation = (idx) => {
    const remaining = item.selected_variations.filter((_, i) => i !== idx);
    // Prevent empty composed menu
    if (remaining.length === 0) {
      alert("Um menu composto deve ter pelo menos um componente.");
      return;
    }
    const updated = { ...item, selected_variations: remaining };
    onSave(updated);
  };

  const itemPrice = item.selected_variations.reduce((sum, v) => sum + (v.price || 0), 0);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Editar {item.product_name}</DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-xs font-semibold text-gray-600 mb-2">COMPONENTES</p>
            {item.selected_variations.map((variation, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between py-2 px-2 hover:bg-gray-100 rounded border-b last:border-b-0"
              >
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900">{variation.name}</p>
                  {variation.quantity > 1 && (
                    <p className="text-xs text-gray-500">{variation.quantity}×</p>
                  )}
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-sm font-semibold text-gray-700">€{(variation.price || 0).toFixed(2)}</span>
                  {item.selected_variations.length > 1 && (
                    <button
                      onClick={() => handleRemoveVariation(idx)}
                      className="w-6 h-6 rounded hover:bg-red-50 flex items-center justify-center"
                    >
                      <Trash2 className="w-3.5 h-3.5 text-red-400 hover:text-red-600" />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="bg-emerald-50 rounded-lg p-2 border border-emerald-200">
            <div className="flex justify-between items-center">
              <span className="text-xs font-semibold text-emerald-700">Preço do Menu</span>
              <span className="text-sm font-bold text-emerald-700">€{itemPrice.toFixed(2)}</span>
            </div>
          </div>

          {item.selected_variations.length === 1 && (
            <p className="text-xs text-red-600 flex items-center gap-1">
              <X className="w-3 h-3" />
              Não é possível remover o último componente.
            </p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isSaving}>
            Cancelar
          </Button>
          <Button
            onClick={onClose}
            disabled={isSaving}
            className="bg-emerald-600 hover:bg-emerald-700 text-white"
          >
            <Check className="w-4 h-4 mr-1" />
            Concluído
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
